import React, { PureComponent } from 'react';
import { isEmptyArray } from '../../../../core/util/array';
import { BASE_URL } from '../../../../config';
import { getNeighborhoodPath } from '../../../../core/util/seo';
import { array } from 'prop-types';
import styled, { css } from 'styled-components';
import { colors } from '../../../../constants/colors';
import { INFO_FIELD_DEFAULT_STATE } from '../../../../constants/clinicDetailPage';

const StyledLink = styled.a`
  &:not(:last-child) {
    &::after {
      content: ', ';
      color: ${colors.blueMonday};
    }
  }

  ${({ href }) =>
    !href &&
    css`
      color: ${colors.blueMonday};
    `}
`;

class NeighborhoodLinks extends PureComponent {
  static propTypes = {
    neighborhoods: array,
  };

  render = () => {
    const { neighborhoods } = this.props;

    if (isEmptyArray(neighborhoods)) {
      return INFO_FIELD_DEFAULT_STATE;
    }

    return neighborhoods.map((neighborhood, i) => {
      const neighborhoodUrl = neighborhood.slug
        ? `${BASE_URL}${getNeighborhoodPath(neighborhood.slug)}`
        : undefined;

      return (
        <StyledLink key={i} href={neighborhoodUrl}>
          {neighborhood.name}
        </StyledLink>
      );
    });
  };
}

export default NeighborhoodLinks;
